import * as React from "react";
import styled from "styled-components";
import useTable from "../../useTable";

import HeaderCell from "../HeaderCell";
import BulkSelectHeaderCell from "../BulkSelectHeaderCell";
import { ROW_HEIGHT } from "../constants";

const Outer = styled.div<{ showShadow: boolean }>`
  transition: box-shadow 0.3s;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, ${p => (p.showShadow ? 0.15 : 0)}),
    0px 1px 2px 0px rgba(0, 0, 0, ${p => (p.showShadow ? 0.1 : 0.1)});
  width: 100%;
  z-index: 1;
  position: relative;
  overflow: hidden;
`;

const Base = styled.div<{ width: number }>`
  display: flex;
  width: ${p => p.width}px;
  min-width: ${p => p.width}px;
`;

function getTotalWidth(columnWidths: number[]) {
  return columnWidths.reduce((total, current) => total + current, 0);
}

type HeaderProps = {
  columnWidths: number[];
  showShadow: boolean;
};

function Header({ columnWidths, showShadow }: HeaderProps, ref: any) {
  const {
    columnConfig,
    getFilter,
    rowColor2,
    setFilterShow,
    toggleSort,
    t,
    sortKey,
    sortDirection,
    hasBulkSelect,
    actions
  } = useTable();

  return (
    <Outer showShadow={showShadow} ref={ref}>
      <Base width={getTotalWidth(columnWidths)}>
        {hasBulkSelect && <BulkSelectHeaderCell showShadow={showShadow} />}

        {columnConfig.map((config, index) => {
          const filter = getFilter(config.key as string);

          return (
            <HeaderCell
              key={config.key as string}
              config={config}
              width={columnWidths[index + (hasBulkSelect ? 1 : 0)]}
              filterShow={filter.show}
              filterValue={filter.value}
              rowColor2={rowColor2}
              setFilterShow={setFilterShow}
              sortDirection={sortDirection}
              sortKey={sortKey}
              t={t}
              toggleSort={toggleSort}
            />
          );
        })}

        {actions && (
          <div
            data-testid="header-cell-actions"
            style={{
              height: ROW_HEIGHT,
              width: actions.width,
              backgroundColor: rowColor2
            }}
          />
        )}
      </Base>
    </Outer>
  );
}

export default React.forwardRef(Header);
